import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageSide300x250Fs from './freestar/DesktopDevPageSide300x250';
import DesktopDevPageSide300x250Tab from './taboola/DesktopDevPageSide300x250';
const DesktopDevPageSide300x250 = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Tab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageSide300x250Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopDevPageSide300x250.displayName = 'DesktopDevPageSide300x250';
export default DesktopDevPageSide300x250;
